/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import React from 'react';
import { getOptionsFromEnum } from '../enumUtils';

import './index.scss';

function RadioOption({
  value,
  option,
  onSelect,

  renderLabel,
  renderDescription,
  isOptionDisabled
}) {
  const isSelected = value === option.value;

  const decription = isSelected && renderDescription?.(option.value, option.text);
  const isDisabled = isOptionDisabled?.(option.value);

  return (
    <div className={`option ${isSelected ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
      onClick={isDisabled ? null : onSelect}>
      <div className="radio-circle">
        <div className="radio-dot"></div>
      </div>
      <div className="label">
        {renderLabel ? renderLabel(option.value, option.text) : option.text}
      </div>

      {isSelected && decription
        ? (
          <div className="description">
            {renderDescription(option.value, option.text)}
          </div>
        )
        : null}
    </div>
  );
}


/**
 * Radio box style form selection select
 */
function RadioSelect ({
  type,
  value,
  onChange,
  hasError,

  renderLabel,
  renderDescription,
  isOptionDisabled
}) {
  let options = getOptionsFromEnum(type);
  return (
    <div className={`component-radio-select ${hasError ? 'error' : ''}`}>
      {options.map((option, index) => {
        return (
          <RadioOption key={option.value}
            value={value}
            option={option}
            renderLabel={renderLabel}
            renderDescription={renderDescription}
            isOptionDisabled={isOptionDisabled}
            onSelect={() => onChange(option.value)} />
        );
      })}
    </div>
  );
}

export default RadioSelect;